import { render, staticRenderFns } from "./backgroundManage.vue?vue&type=template&id=0f537fc6&"
import script from "./backgroundManage.vue?vue&type=script&lang=js&"
export * from "./backgroundManage.vue?vue&type=script&lang=js&"
import style0 from "./backgroundManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports